export default __webpack_public_path__ + "static/media/doll.1ee19dab.png";